define('model/routing/routing',[], function() {
    'use strict';

    function newFeature(summary, isMultiLineString) {
        return {
            type: 'Feature',
            geometry: {type: isMultiLineString ? 'MultiLineString' : 'LineString', coordinates: []},
            properties: {summary: summary, segmentSummary: []}
        };
    }

    function newFeatureCollection() {
        return {
            type: 'FeatureCollection',
            features: []
        };
    }

    function getCoordinates(points) {
        var coordinates = [];
        var i;
        for (i = 0; i < points.length; i += 1) {
            coordinates.push([points[i].longitude, points[i].latitude]);
        }
        return coordinates;
    }

    function getRouteFeature(route) {
        var isMultiLineString = route.legs.length > 1;
        var feature = newFeature(route.summary, isMultiLineString);
        var i;
        for (i = 0; i < route.legs.length; i += 1) {
            feature.properties.segmentSummary.push(route.legs[i].summary);
            if (isMultiLineString) {
                feature.geometry.coordinates.push(getCoordinates(route.legs[i].points));
            } else {
                feature.geometry.coordinates = getCoordinates(route.legs[i].points);
            }
        }
        if (route.guidance) {
            feature.properties.guidance = route.guidance;
        }
        return feature;
    }

    return function(data) {
        var result = newFeatureCollection();
        var i;
        if (!data || !data.routes) {
            return result;
        }
        for (i = 0; i < data.routes.length; i += 1) {
            result.features.push(getRouteFeature(data.routes[i]));
        }
        return result;
    };
});

